import { render } from "./TroyersCheese.vue?vue&type=template&id=9980bfda&scoped=true"
import script from "./TroyersCheese.vue?vue&type=script&lang=js"
export * from "./TroyersCheese.vue?vue&type=script&lang=js"

import "./TroyersCheese.vue?vue&type=style&index=0&id=9980bfda&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9980bfda"]])

export default __exports__